<template>    
    <div class="Frame">
        <div class="ItemMainDataBox">
            <div class="ItemMainDataImageBox">
                <div class="ItemMainDataImage"><span><img :src="this.mainImage" alt="" /></span></div>
                <div class="ItemMainDataImageThumbBox">
                    <template v-if="this.ModelImages.length > 0">
                    <ul>
                        <li v-for="(image, index) in this.ModelImages" :key="index">
                            <a href="javascript:void(0)"><i><img @click="this.getImmaginePrincipale(image.UrlAllegato)" :src="image.UrlAllegato" alt="" /></i></a>
                        </li>                        
                    </ul>
                    </template>
                </div>                            
            </div>
            <div class="ItemMainDataInfo">
                <div class="ItemIndex">{{this.$store.getters.getCatalogName(this.currentmodel.IdCatalogo)}}</div>
                <h1 class="ModelTitle">{{ this.currentmodel.Descrizione}}</h1>
                <h2>{{ this.currentmodel.IdModello }}</h2>
                <p>{{ this.currentmodel.DescrizioneEstesa }}</p>
                
                <div v-for="(video, index) in this.modelVideo" :key="index" class="Button Iconed CustomColor Big Play">                    
                    <a  href="javascript:void(0)" @click="this.showPopUpViedeo(video.UrlVideo)">{{ this.risorse["GuardaVideo"] }}</a>                   
                </div>
            </div>    
            <div class="ItemMainDataAction">
                <div class="ItemIndex">{{ this.risorse["Documentazione"] }}</div>
                <div class="ItemMainDataButtonBox">

                    <div v-for="(all, index) in this.modelDocs" :key="index" class="Button Iconed Big Download">
                        <a target="_blank" :href="this.getUrlImmagineFull(all.UrlAllegato)"> {{all.Titolo}} </a>
                    </div>
                    <div v-for="(all, index) in this.modelsManuals" :key="index"  class="Button Iconed Big Download">
                        <a target="_blank" :href="this.getUrlImmagineFull(all.UrlAllegato)">{{all.Titolo}}</a>
                    </div> 
                </div>
            </div>
        </div>
    </div>    
    <ModalYoutube :videoLink="this.videoToShow" v-model="this.showModal"></ModalYoutube>       
</template>

<script>

import {imgMixin, risorseMixin} from "@/mixin.js";
import ModalYoutube from "@/components/modals/ModalYoutube.vue";

export default {
    name: "ModelElements",
    data(){
        return {
            currentmodel: {}, 
            ModelImages: [],
            mainImage: "",
            modelDocs: [],
            modelsManuals: [],
            modelVideo: [],
            showModal: false,
            videoToShow: ""   
        }
    },
    props: {
        model: Object        
    },
    mixins:[
        imgMixin, risorseMixin
    ],
    components:{
        ModalYoutube
    },
    watch: {
        model: function(newData){
            this.isLoading = true;           
            this.resetData();
            this.setCurrentModel(newData); 
            this.isLoading = false;                  
        }
    },
    methods: {
        showPopUpViedeo(video){                       
            this.videoToShow = video;
            this.showModal = true;
        },        
        getImmaginePrincipale(img){
            this.mainImage = this.getUrlImmagineFull(img,true);                
        },
        setUrlAllegati(){
            this.ModelImages.forEach(element => {
                element.UrlAllegato = this.getUrlImmagineArticolo(element.UrlAllegato);
            });
        },
        getAllegati(){           
            if(this.currentmodel?.UrlImmagine){
                this.ModelImages.push({UrlAllegato: this.currentmodel.UrlImmagine});                      
            }
            this.currentmodel?.Allegati?.forEach(element => {
                if(element.TipoAllegato == "IMG"){
                    this.ModelImages.push(element);
                }
                else if(element.TipoAllegato == "DOC1_ING" || element.TipoAllegato == "DOC1_ITA"){                    
                    this.modelDocs.push(element)
                }
                else if(element.TipoAllegato == "MAN_ITA" || element.TipoAllegato == "MAN_ING"){
                    this.modelsManuals.push(element)
                }
            });
            this.setUrlAllegati();          
        },
        getVideo(){
            this.currentmodel.Video.forEach(element => {
                this.modelVideo.push(element) 
            });
        },
        setCurrentModel(newData){
            this.currentmodel = newData;
            this.getImmaginePrincipale(this.currentmodel.UrlImmagine);
            this.getAllegati();
            this.getVideo();
        },
        resetData(){
            this.currentmodel = {};
            this.ModelImages = [];
            this.mainImage = "";
            this.modelDocs = [];
            this.modelsManuals = [];
            this.modelVideo = [];
        }
    }    
}
</script>
<style>
.ModelTitle{
    width: 100%;
}
</style>